<nav
  class="navbar navbar-top navbar-expand navbar-dark bg-danger border-bottom"
  id="navbar-main"
  [ngStyle]="{ 'background-color': bgColor + ' !important' }"
>
  <div class="container-fluid">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">

    <!-- LEFT GROUP: toggler + logo -->
    <div class="navbar-left-group d-flex align-items-center" [class.pushed]="sidenavOpen">
      <ul class="navbar-nav align-items-center">
        <li class="nav-item d-xl-none">
          <div
            class="pr-3 sidenav-toggler sidenav-toggler-dark"
            (click)="openSidebar()"
          >
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </li>
      </ul>

      <a class="navbar-top-brand" [routerLink]="['/home']">
        <img src="assets/img/brand/white.png" alt="securipay-logo" class="navbar-brand-img" />
      </a>
    </div>



      <!-- User -->
      <ul class="navbar-nav align-items-center ml-auto ml-md-0">

        <!-- ① Avatar — Profile Photo dropdown -->
        <li
          class="nav-item dropdown"
          dropdown
          placement="bottom-right"
          [isOpen]="showProfileModal"
          (isOpenChange)="onProfileDropdownToggle($event)"
        >
          <a class="nav-link pr-0" role="button" dropdownToggle style="cursor: pointer;">
            <span class="avatar avatar-sm rounded-circle" style="overflow:hidden; display:inline-flex; vertical-align:middle;">
              <img
                alt="Image placeholder"
                [src]="profilePhotoUrl || 'assets/img/theme/no-profile-placeholder.png'"
                style="width:100%; height:100%; object-fit:cover; border-radius:50%;"
              />
            </span>
          </a>

          <div
            class="dropdown-menu dropdown-menu-arrow dropdown-menu-right"
            *dropdownMenu
            style="width: min(400px, 95vw); min-width: 0; padding: 0; overflow: hidden; border-radius: 12px;"
            (click)="$event.stopPropagation()"
          >
            <app-profile-photo-modal
              *ngIf="showProfileModal"
              [profilePhotoUrl]="profilePhotoUrl"
              (closed)="onProfileDropdownToggle(false)"
              (photoUpdated)="onPhotoUpdated($event)">
            </app-profile-photo-modal>
          </div>
        </li>

        <!-- ② Username — Settings / Logout dropdown -->
        <li class="nav-item dropdown" dropdown placement="bottom-right">
          <a class="nav-link pl-1 pr-0 dropdown-toggle" role="button" dropdownToggle>
            <div class="media align-items-center">
              <div class="media-body ml-2 d-lg-block">
                <span class="mb-0 text-sm font-weight-bold">{{ username }}</span>
              </div>
            </div>
          </a>
          <div
            class="dropdown-menu dropdown-menu-arrow dropdown-menu-right"
            *dropdownMenu
          >
            <!-- <a
              routerLinkActive="active"
              [routerLink]="['/features/profile']"
              class="dropdown-item"
            >
              <i class="ni ni-single-02"></i> <span>My profile</span>
            </a> -->
            <a [routerLink]="['/home']" routerLinkActive="active" class="dropdown-item">
              <i class="fas fa-home"></i>
              <span>Home</span>
            </a>
            <a [routerLink]="['/features/user-guide']" routerLinkActive="active" class="dropdown-item">
              <i class="fas fa-book"></i>
              <span> User Guide</span>
            </a>
            <a
              routerLinkActive="active"
              [routerLink]="['/features/timeline']"
              class="dropdown-item"
            >
              <i class="ni ni-settings-gear-65"></i> <span>Settings</span>
            </a>
            <a href="javascript:void(0)" (click)="openChangePasswordModal()" class="dropdown-item">
                <span style="display: inline-flex; align-items: center; width: 1.25rem; margin-right: 0.5rem;">
                    <iconify-icon icon="material-symbols:key" width="16" height="16"></iconify-icon>
                </span>
                <span>Change Password</span>
            </a>
            <div class="dropdown-divider"></div>
            <a href="javascript:void(0)" (click)="onLogout()" class="dropdown-item">
              <i class="ni ni-user-run"></i> <span>Logout</span>
            </a>
          </div>
        </li>

      </ul>
    </div>
  </div>
</nav>

<div
  *ngIf="sidenavOpen === true"
  class="backdrop d-xl-none"
  (click)="closeSidenav()"
></div>